import { graphql } from 'gatsby'
import Layout from 'components/layout/layout'
import HomeFeatures from 'components/home/homeFeatures'
import HomeMap from 'components/home/homeMap'
import Hero from 'components/slices/hero'
import Stories from 'components/slices/stories'
import HomeSiteTypes from 'components/home/homeSiteTypes'
import HomeScenes from 'components/home/homeScenes'
import Seasons from 'components/slices/seasons'
import Experience from 'components/slices/experience'
import FAQContainer from 'components/slices/faqContainer'
import { Spacer } from 'components/common/common_styles'
import SEO from 'components/common/seo'

const Home = props => {
  const data = props.data.prismicHomePage.data

  return (
    <Layout $home>
      <Hero data={data.hero[0]} showBookingWidget home />
      <Seasons data={data.seasons[0]} />
      <HomeSiteTypes />
      <HomeFeatures />
      <HomeMap />
      <Experience data={data.experience[0]} black />
      <Stories washi />
      <Spacer desktopHeight={116} mobileHeight={148} washi />
      <HomeScenes />
      <FAQContainer data={data.faq[0]} />
    </Layout>
  )
}

export default Home

export const Head = () =>
  <SEO title='Home' />

export const query = graphql`
  query {
    prismicHomePage {
      data {
        hero {
          ... on PrismicHomePageDataHeroHero {
            primary {
              desktop_image {
                alt
                gatsbyImageData(layout: FULL_WIDTH)
                url
              }
              mobile_image {
                gatsbyImageData(layout: FULL_WIDTH)
                alt
                url
              }
              desktop_video {
                url
              }
              mobile_video {
                url
              }
              title
              welcome
            }
          }
        }
        seasons {
          ... on PrismicHomePageDataSeasonsSeasons {
            id
            primary {
              title
              copy {
                richText
              }
              button_link
              button_title
              spring_title
              spring_copy {
                richText
              }
              spring_image {
                alt
                gatsbyImageData
              }
              summer_title
              summer_copy {
                richText
              }
              summer_image {
                alt
                gatsbyImageData
              }
              autumn_title
              autumn_copy {
                richText
              }
              autumn_image {
                alt
                gatsbyImageData
              }
              winter_title
              winter_copy {
                richText
              }
              winter_image {
                alt
                gatsbyImageData
              }
            }
          }
        }
        experience {
          ... on PrismicHomePageDataExperienceExperience {
            id
            items {
              image {
                alt
                gatsbyImageData
              }
              title
              link
            }
            primary {
              button_link
              button_title
              title
              copy {
                richText
              }
            }
          }
        }
        faq {
          ... on PrismicHomePageDataFaqFaqs {
            primary {
              faq_title
            }
            items {
              question
              answer {
                richText
              }
            }
          }
        }
      }
    }
  }
`
